import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withCtx as _withCtx, vModelText as _vModelText } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "card" }, [
  /*#__PURE__*/_createVNode("h1", { class: "title mb-2" }, [
    /*#__PURE__*/_createVNode("i", { class: "fa fa-file fa-w-12 mr-1" }),
    /*#__PURE__*/_createTextVNode(" Received Invoice ")
  ])
], -1)
const _hoisted_4 = {
  key: 1,
  class: "card"
}
const _hoisted_5 = { class: "inline-items" }
const _hoisted_6 = /*#__PURE__*/_createVNode("li", null, [
  /*#__PURE__*/_createVNode("label", {
    for: "invoice",
    class: "mt-1"
  }, "Choose a Invoice:")
], -1)
const _hoisted_7 = { class: "card" }
const _hoisted_8 = { class: "row align-items-center" }
const _hoisted_9 = { class: "col-md-8" }
const _hoisted_10 = { class: "inline-items" }
const _hoisted_11 = {
  key: 0,
  class: "mr-md-5"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Invoice No: ")
const _hoisted_13 = { class: "green-text" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Invoice Date: ")
const _hoisted_16 = { class: "green-text" }
const _hoisted_17 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_18 = { class: "text-md-right" }
const _hoisted_19 = /*#__PURE__*/_createVNode("strong", null, "Status :", -1)
const _hoisted_20 = {
  key: 0,
  class: "badge badge-dim badge-warning ml-1"
}
const _hoisted_21 = {
  key: 1,
  class: "badge badge-dim badge-warning ml-1 text-orange"
}
const _hoisted_22 = {
  key: 2,
  class: "badge badge-dim badge-warning ml-1 text-green"
}
const _hoisted_23 = {
  key: 3,
  class: "badge badge-dim badge-warning ml-1 text-red"
}
const _hoisted_24 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-md-6" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Billed From :")
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { key: 2 }
const _hoisted_31 = { key: 3 }
const _hoisted_32 = { key: 4 }
const _hoisted_33 = { key: 5 }
const _hoisted_34 = { class: "col-md-6" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode("Billed To :")
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = { key: 2 }
const _hoisted_41 = { key: 3 }
const _hoisted_42 = { key: 4 }
const _hoisted_43 = { key: 5 }
const _hoisted_44 = { class: "mt-4" }
const _hoisted_45 = /*#__PURE__*/_createTextVNode("Title :")
const _hoisted_46 = { class: "table-responsive my-3 font-12" }
const _hoisted_47 = { class: "table table-bordered table-shadowed mb-0" }
const _hoisted_48 = { class: "table-primary nowrap-text" }
const _hoisted_49 = /*#__PURE__*/_createVNode("th", { scope: "col" }, "Description", -1)
const _hoisted_50 = /*#__PURE__*/_createVNode("th", { scope: "col" }, "Cost/hrs", -1)
const _hoisted_51 = /*#__PURE__*/_createVNode("th", { scope: "col" }, "Qty/hrs", -1)
const _hoisted_52 = /*#__PURE__*/_createVNode("th", { scope: "col" }, "Amount", -1)
const _hoisted_53 = {
  key: 0,
  scope: "col"
}
const _hoisted_54 = { key: 0 }
const _hoisted_55 = { class: "table-input-checked-wrap" }
const _hoisted_56 = /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" }, null, -1)
const _hoisted_57 = /*#__PURE__*/_createVNode("i", { class: "fa fa-minus" }, null, -1)
const _hoisted_58 = { key: 1 }
const _hoisted_59 = {
  key: 0,
  class: "row"
}
const _hoisted_60 = { class: "col-md-4 offset-md-8" }
const _hoisted_61 = { class: "shadowed-card" }
const _hoisted_62 = { class: "row" }
const _hoisted_63 = /*#__PURE__*/_createVNode("div", { class: "col-6" }, [
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createVNode("strong", null, "SubTotal")
  ])
], -1)
const _hoisted_64 = { class: "col-6 text-right" }
const _hoisted_65 = { class: "mb-1" }
const _hoisted_66 = /*#__PURE__*/_createVNode("div", { class: "col-6" }, [
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createVNode("strong", null, "Tax")
  ])
], -1)
const _hoisted_67 = { class: "col-6 text-right" }
const _hoisted_68 = { class: "mb-1" }
const _hoisted_69 = /*#__PURE__*/_createVNode("div", { class: "col-6" }, [
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createVNode("strong", null, "Discount")
  ])
], -1)
const _hoisted_70 = { class: "col-6 text-right" }
const _hoisted_71 = { class: "mb-1" }
const _hoisted_72 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_73 = { class: "row" }
const _hoisted_74 = { class: "col-6" }
const _hoisted_75 = /*#__PURE__*/_createTextVNode("Total")
const _hoisted_76 = { class: "col-6 text-right" }
const _hoisted_77 = { key: 0 }
const _hoisted_78 = { key: 1 }
const _hoisted_79 = {
  key: 1,
  class: "row"
}
const _hoisted_80 = { class: "col-md-4 offset-md-8" }
const _hoisted_81 = { class: "shadowed-card" }
const _hoisted_82 = { class: "row" }
const _hoisted_83 = /*#__PURE__*/_createVNode("div", { class: "col-6" }, [
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createVNode("strong", null, "SubTotal")
  ])
], -1)
const _hoisted_84 = { class: "col-6 text-right" }
const _hoisted_85 = { key: 0 }
const _hoisted_86 = { key: 1 }
const _hoisted_87 = { class: "col-12" }
const _hoisted_88 = /*#__PURE__*/_createVNode("div", { class: "col-6" }, [
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createVNode("strong", null, "Discount")
  ])
], -1)
const _hoisted_89 = { class: "col-6 text-right" }
const _hoisted_90 = { key: 0 }
const _hoisted_91 = { key: 1 }
const _hoisted_92 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_93 = { class: "row" }
const _hoisted_94 = { class: "col-6" }
const _hoisted_95 = /*#__PURE__*/_createTextVNode("Total")
const _hoisted_96 = { class: "col-6 text-right" }
const _hoisted_97 = { key: 0 }
const _hoisted_98 = { key: 1 }
const _hoisted_99 = { class: "inline-items" }
const _hoisted_100 = { key: 0 }
const _hoisted_101 = { key: 1 }
const _hoisted_102 = { key: 2 }
const _hoisted_103 = { key: 3 }
const _hoisted_104 = { class: "modal-wrap default-modal" }
const _hoisted_105 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "allInvoiceGenerate",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_106 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_107 = { class: "modal-content" }
const _hoisted_108 = { class: "modal-header" }
const _hoisted_109 = /*#__PURE__*/_createVNode("div", { class: "d-block" }, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "exampleModalLabel"
  }, "All Invoice"),
  /*#__PURE__*/_createVNode("p", { class: "text-muted" }, " All received invoices are listed to create invoice. ")
], -1)
const _hoisted_110 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_111 = { class: "modal-body" }
const _hoisted_112 = /*#__PURE__*/_createVNode("p", null, "Do you want to include generated/drafted invoice?", -1)
const _hoisted_113 = { class: "modal-wrap default-modal" }
const _hoisted_114 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "generateConfirmationModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_115 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_116 = { class: "modal-content" }
const _hoisted_117 = { class: "modal-header" }
const _hoisted_118 = /*#__PURE__*/_createVNode("div", { class: "d-block" }, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "exampleModalLabel"
  }, " Generate Invoice ")
], -1)
const _hoisted_119 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_120 = { class: "modal-body" }
const _hoisted_121 = /*#__PURE__*/_createVNode("p", null, "Do you want to create Invoice ?", -1)
const _hoisted_122 = { key: 0 }
const _hoisted_123 = /*#__PURE__*/_createVNode("p", null, "You don't have Stripe Account !!!", -1)
const _hoisted_124 = { key: 1 }
const _hoisted_125 = { key: 1 }
const _hoisted_126 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BreadcrumbRequestedInvoice = _resolveComponent("BreadcrumbRequestedInvoice")
  const _component_big = _resolveComponent("big")
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.state.ui.isLoading.phaseInvoiceListById && _ctx.state.ui.isLoading.getInvoiceByPhaseOrTask)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _hoisted_2
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_BreadcrumbRequestedInvoice, {
      breadcrumbList: _ctx.state.data.breadcrumb
    }, null, 8, ["breadcrumbList"]),
    _hoisted_3,
    (_ctx.state.data.invoices && _ctx.state.data.invoices.length)
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("ul", null, [
              _hoisted_6,
              _createVNode("li", null, [
                _withDirectives(_createVNode("select", {
                  class: "form-control",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.data.selectedInvoice = $event)),
                  onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getInvoiceByPhaseOrTask(_ctx.state.data.selectedInvoice)))
                }, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.invoices, (invoice, invoiceIndex) => {
                    return (_openBlock(), _createBlock("option", {
                      value: invoice,
                      key: invoiceIndex
                    }, " #" + _toDisplayString(invoice.invoice_no) + "(" + _toDisplayString(invoice.invoice_date) + ") ", 9, ["value"]))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.state.data.selectedInvoice]
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_7, [
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _createVNode("ul", null, [
              (
                  _ctx.state.data.invoiceDetails &&
                  _ctx.state.data.invoiceDetails.invoice_no
                )
                ? (_openBlock(), _createBlock("li", _hoisted_11, [
                    _createVNode("p", null, [
                      _createVNode(_component_big, null, {
                        default: _withCtx(() => [
                          _createVNode("strong", null, [
                            _hoisted_12,
                            _createVNode("span", _hoisted_13, "#" + _toDisplayString(_ctx.state.data.invoiceDetails.invoice_no), 1)
                          ])
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode("li", null, [
                (
                    _ctx.state.data.invoiceDetails &&
                    _ctx.state.data.invoiceDetails.invoice_date
                  )
                  ? (_openBlock(), _createBlock("p", _hoisted_14, [
                      _createVNode(_component_big, null, {
                        default: _withCtx(() => [
                          _createVNode("strong", null, [
                            _hoisted_15,
                            _createVNode("span", _hoisted_16, _toDisplayString(_ctx.state.data.invoiceDetails.invoice_date), 1)
                          ])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        (_ctx.state.data.invoiceDetails && _ctx.state.data.invoiceDetails.status)
          ? (_openBlock(), _createBlock("div", _hoisted_17, [
              _createVNode("div", _hoisted_18, [
                _createVNode("p", null, [
                  _hoisted_19,
                  (_ctx.state.data.invoiceDetails.status === 1)
                    ? (_openBlock(), _createBlock("span", _hoisted_20, "Pending"))
                    : _createCommentVNode("", true),
                  (_ctx.state.data.invoiceDetails.status === 2)
                    ? (_openBlock(), _createBlock("span", _hoisted_21, "Partial Paid"))
                    : _createCommentVNode("", true),
                  (_ctx.state.data.invoiceDetails.status === 3)
                    ? (_openBlock(), _createBlock("span", _hoisted_22, "Paid"))
                    : _createCommentVNode("", true),
                  (_ctx.state.data.invoiceDetails.status === 4)
                    ? (_openBlock(), _createBlock("span", _hoisted_23, "Draft"))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_24,
      _createVNode(_component_ErrorList, {
        errors: _ctx.state.ui.error.errorList.getInvoiceByPhaseOrTask,
        hasError: _ctx.state.ui.error.hasError
      }, null, 8, ["errors", "hasError"]),
      _createVNode("div", _hoisted_25, [
        _createVNode("div", _hoisted_26, [
          _createVNode("p", null, [
            _createVNode("strong", null, [
              _createVNode(_component_big, null, {
                default: _withCtx(() => [
                  _hoisted_27
                ]),
                _: 1
              })
            ])
          ]),
          (
              _ctx.state.data.invoiceDetails.billed_from_user &&
              _ctx.state.data.invoiceDetails.billed_from_user.email
            )
            ? (_openBlock(), _createBlock("p", _hoisted_28, _toDisplayString(_ctx.state.data.invoiceDetails.billed_from_user.email), 1))
            : _createCommentVNode("", true),
          (
              _ctx.state.data.invoiceDetails.billed_from_user &&
              _ctx.state.data.invoiceDetails.billed_from_user.full_name
            )
            ? (_openBlock(), _createBlock("p", _hoisted_29, _toDisplayString(_ctx.state.data.invoiceDetails.billed_from_user.full_name), 1))
            : _createCommentVNode("", true),
          (
              _ctx.state.data.invoiceDetails.billed_from_user &&
              _ctx.state.data.invoiceDetails.billed_from_user.address_line1
            )
            ? (_openBlock(), _createBlock("p", _hoisted_30, _toDisplayString(_ctx.state.data.invoiceDetails.billed_from_user.address_line1), 1))
            : _createCommentVNode("", true),
          (
              _ctx.state.data.invoiceDetails.billed_from_user &&
              _ctx.state.data.invoiceDetails.billed_from_user.address_line2
            )
            ? (_openBlock(), _createBlock("p", _hoisted_31, _toDisplayString(_ctx.state.data.invoiceDetails.billed_from_user.address_line2), 1))
            : _createCommentVNode("", true),
          (
              _ctx.state.data.invoiceDetails.billed_from_user &&
              _ctx.state.data.invoiceDetails.billed_from_user.city
            )
            ? (_openBlock(), _createBlock("p", _hoisted_32, _toDisplayString(_ctx.state.data.invoiceDetails.billed_from_user.city), 1))
            : _createCommentVNode("", true),
          (
              _ctx.state.data.invoiceDetails.billed_from_user &&
              _ctx.state.data.invoiceDetails.billed_from_user.country
            )
            ? (_openBlock(), _createBlock("p", _hoisted_33, _toDisplayString(_ctx.state.data.invoiceDetails.billed_from_user.country), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_34, [
          _createVNode("p", null, [
            _createVNode("strong", null, [
              _createVNode(_component_big, null, {
                default: _withCtx(() => [
                  _hoisted_35
                ]),
                _: 1
              })
            ])
          ]),
          (_ctx.state.data.invoiceReceiverList && _ctx.state.data.invoiceReceiverList.length > 0 && _ctx.state.data.invoiceDetails.to_role != 2)
            ? (_openBlock(), _createBlock("div", _hoisted_36, [
                _withDirectives(_createVNode("select", {
                  class: "form-control",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.data.invoiceBillTo = $event))
                }, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.invoiceReceiverList, (invoice, invoiceIndex) => {
                    return (_openBlock(), _createBlock("option", {
                      value: invoice,
                      key: invoiceIndex
                    }, _toDisplayString(invoice.full_name) + "(" + _toDisplayString(invoice.email) + ") ", 9, ["value"]))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.state.data.invoiceBillTo]
                ])
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_37, [
                (
                _ctx.state.data.invoiceDetails.billed_to_user &&
                _ctx.state.data.invoiceDetails.billed_to_user.email
              )
                  ? (_openBlock(), _createBlock("p", _hoisted_38, _toDisplayString(_ctx.state.data.invoiceDetails.billed_to_user.email), 1))
                  : _createCommentVNode("", true),
                (
                _ctx.state.data.invoiceDetails.billed_to_user &&
                _ctx.state.data.invoiceDetails.billed_to_user.full_name
              )
                  ? (_openBlock(), _createBlock("p", _hoisted_39, _toDisplayString(_ctx.state.data.invoiceDetails.billed_to_user.full_name), 1))
                  : _createCommentVNode("", true),
                (
                _ctx.state.data.invoiceDetails.billed_to_user &&
                _ctx.state.data.invoiceDetails.billed_to_user.address_line1
              )
                  ? (_openBlock(), _createBlock("p", _hoisted_40, _toDisplayString(_ctx.state.data.invoiceDetails.billed_to_user.address_line1), 1))
                  : _createCommentVNode("", true),
                (
                _ctx.state.data.invoiceDetails.billed_to_user &&
                _ctx.state.data.invoiceDetails.billed_to_user.address_line2
              )
                  ? (_openBlock(), _createBlock("p", _hoisted_41, _toDisplayString(_ctx.state.data.invoiceDetails.billed_to_user.address_line2), 1))
                  : _createCommentVNode("", true),
                (
                _ctx.state.data.invoiceDetails.billed_to_user &&
                _ctx.state.data.invoiceDetails.billed_to_user.city
              )
                  ? (_openBlock(), _createBlock("p", _hoisted_42, _toDisplayString(_ctx.state.data.invoiceDetails.billed_to_user.city), 1))
                  : _createCommentVNode("", true),
                (
                _ctx.state.data.invoiceDetails.billed_to_user &&
                _ctx.state.data.invoiceDetails.billed_to_user.country
              )
                  ? (_openBlock(), _createBlock("p", _hoisted_43, _toDisplayString(_ctx.state.data.invoiceDetails.billed_to_user.country), 1))
                  : _createCommentVNode("", true)
              ]))
        ])
      ]),
      _createVNode("p", _hoisted_44, [
        _createVNode("strong", null, [
          _createVNode(_component_big, null, {
            default: _withCtx(() => [
              _hoisted_45
            ]),
            _: 1
          })
        ]),
        _createTextVNode(" " + _toDisplayString(_ctx.state.data.invoiceDetails.title), 1)
      ]),
      _createVNode("div", _hoisted_46, [
        _createVNode("table", _hoisted_47, [
          _createVNode("thead", _hoisted_48, [
            _createVNode("tr", null, [
              _hoisted_49,
              _hoisted_50,
              _hoisted_51,
              _hoisted_52,
              (_ctx.isAuthEdit)
                ? (_openBlock(), _createBlock("th", _hoisted_53, "Action"))
                : _createCommentVNode("", true)
            ])
          ]),
          (
              _ctx.isAuthEdit &&
              _ctx.state.data.invoiceDetails.invoice_items &&
              _ctx.state.data.invoiceDetails.invoice_items.length
            )
            ? (_openBlock(), _createBlock("tbody", _hoisted_54, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.invoiceCalculate, (invoiceDetail, invoiceDetailIndex) => {
                  return (_openBlock(), _createBlock("tr", {
                    key: invoiceDetailIndex,
                    class: invoiceDetail.newAdded ? 'account-pending-invoice' : ''
                  }, [
                    _createVNode("td", null, [
                      _createVNode("div", _hoisted_55, [
                        _withDirectives(_createVNode("input", {
                          type: "text",
                          class: "form-control",
                          "onUpdate:modelValue": ($event: any) => (invoiceDetail.title = $event)
                        }, null, 8, ["onUpdate:modelValue"]), [
                          [_vModelText, invoiceDetail.title]
                        ]),
                        (invoiceDetail.invoice_uuid)
                          ? (_openBlock(), _createBlock("div", {
                              key: 0,
                              class: 
                      invoiceDetail.invoice_uuid
                        ? 'input-checked-round-wrap'
                        : ''
                    
                            }, [
                              _createVNode("i", {
                                class: invoiceDetail.invoice_uuid ? 'fas fa-check' : ''
                              }, null, 2)
                            ], 2))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createVNode("td", null, [
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": ($event: any) => (invoiceDetail.cost = $event)
                      }, null, 8, ["onUpdate:modelValue"]), [
                        [_vModelText, invoiceDetail.cost]
                      ])
                    ]),
                    _createVNode("td", null, [
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": ($event: any) => (invoiceDetail.quantity = $event)
                      }, null, 8, ["onUpdate:modelValue"]), [
                        [_vModelText, invoiceDetail.quantity]
                      ])
                    ]),
                    _createVNode("td", null, [
                      _withDirectives(_createVNode("input", {
                        disabled: "",
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": ($event: any) => (invoiceDetail.amount = $event)
                      }, null, 8, ["onUpdate:modelValue"]), [
                        [_vModelText, invoiceDetail.amount]
                      ])
                    ]),
                    _createVNode("td", null, [
                      (invoiceDetailIndex + 1 === _ctx.invoiceCalculate.length)
                        ? (_openBlock(), _createBlock("a", {
                            key: 0,
                            href: "javascript:void(0)",
                            class: "btn enable-btn mr-1",
                            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addItemInInvoice && _ctx.addItemInInvoice(...args)))
                          }, [
                            _hoisted_56
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode("a", {
                        href: "javascript:void(0)",
                        class: "btn delete-btn mr-1",
                        onClick: ($event: any) => (_ctx.removeSelectedItemInInvoice(invoiceDetail))
                      }, [
                        _hoisted_57
                      ], 8, ["onClick"])
                    ])
                  ], 2))
                }), 128))
              ]))
            : (_openBlock(), _createBlock("tbody", _hoisted_58, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data
                .invoiceDetails.invoice_items, (invoiceDetail, invoiceDetailIndex) => {
                  return (_openBlock(), _createBlock("tr", { key: invoiceDetailIndex }, [
                    _createVNode("td", null, _toDisplayString(invoiceDetail.title), 1),
                    _createVNode("td", null, "$ " + _toDisplayString(invoiceDetail.cost), 1),
                    _createVNode("td", null, _toDisplayString(invoiceDetail.quantity), 1),
                    _createVNode("td", null, "$ " + _toDisplayString(invoiceDetail.amount), 1)
                  ]))
                }), 128))
              ]))
        ])
      ]),
      (_ctx.isAuthEdit)
        ? (_openBlock(), _createBlock("div", _hoisted_59, [
            _createVNode("div", _hoisted_60, [
              _createVNode("div", _hoisted_61, [
                _createVNode("div", _hoisted_62, [
                  _hoisted_63,
                  _createVNode("div", _hoisted_64, [
                    _createVNode("div", _hoisted_65, [
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.data.invoice.subTotal = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.state.data.invoice.subTotal]
                      ])
                    ])
                  ]),
                  _hoisted_66,
                  _createVNode("div", _hoisted_67, [
                    _createVNode("div", _hoisted_68, [
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.data.invoice.tax = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.state.data.invoice.tax]
                      ])
                    ])
                  ]),
                  _hoisted_69,
                  _createVNode("div", _hoisted_70, [
                    _createVNode("div", _hoisted_71, [
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.data.invoice.discount = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.state.data.invoice.discount]
                      ])
                    ])
                  ])
                ]),
                _hoisted_72,
                _createVNode("div", _hoisted_73, [
                  _createVNode("div", _hoisted_74, [
                    _createVNode("p", null, [
                      _createVNode("strong", null, [
                        _createVNode(_component_big, null, {
                          default: _withCtx(() => [
                            _hoisted_75
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_76, [
                    (_ctx.state.data.invoice.total)
                      ? (_openBlock(), _createBlock("p", _hoisted_77, " $" + _toDisplayString(_ctx.state.data.invoice.total), 1))
                      : (_openBlock(), _createBlock("p", _hoisted_78, "$0"))
                  ])
                ])
              ])
            ])
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_79, [
            _createVNode("div", _hoisted_80, [
              _createVNode("div", _hoisted_81, [
                _createVNode("div", _hoisted_82, [
                  _hoisted_83,
                  _createVNode("div", _hoisted_84, [
                    (_ctx.state.data.invoiceDetails.sub_total)
                      ? (_openBlock(), _createBlock("p", _hoisted_85, " $" + _toDisplayString(_ctx.state.data.invoiceDetails.sub_total), 1))
                      : (_openBlock(), _createBlock("p", _hoisted_86, "$0"))
                  ]),
                  _createVNode("div", _hoisted_87, [
                    _createVNode("p", null, [
                      _createVNode("strong", null, "Tax (" + _toDisplayString(_ctx.state.data.invoiceDetails.tax) + "%)", 1)
                    ])
                  ]),
                  _hoisted_88,
                  _createVNode("div", _hoisted_89, [
                    (_ctx.state.data.invoiceDetails.discount)
                      ? (_openBlock(), _createBlock("p", _hoisted_90, " $" + _toDisplayString(_ctx.state.data.invoiceDetails.discount), 1))
                      : (_openBlock(), _createBlock("p", _hoisted_91, "$0"))
                  ])
                ]),
                _hoisted_92,
                _createVNode("div", _hoisted_93, [
                  _createVNode("div", _hoisted_94, [
                    _createVNode("p", null, [
                      _createVNode("strong", null, [
                        _createVNode(_component_big, null, {
                          default: _withCtx(() => [
                            _hoisted_95
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_96, [
                    (
                    _ctx.state.data.invoiceDetails && _ctx.state.data.invoiceDetails.total
                  )
                      ? (_openBlock(), _createBlock("p", _hoisted_97, " $" + _toDisplayString(_ctx.state.data.invoiceDetails.total), 1))
                      : (_openBlock(), _createBlock("p", _hoisted_98, "$0"))
                  ])
                ])
              ])
            ])
          ])),
      _createVNode("div", _hoisted_99, [
        _createVNode("ul", null, [
          (
              _ctx.state.data.isPayActive &&
              _ctx.state.data.invoiceDetails.invoice_items &&
              _ctx.state.data.invoiceDetails.invoice_items.length &&
              _ctx.state.data.selectedInvoice &&
              _ctx.state.data.selectedInvoice.invoice_no != 'All'
            )
            ? (_openBlock(), _createBlock("li", _hoisted_100, [
                _createVNode("a", {
                  id: "createNewProject",
                  href: "javascript:void(0)",
                  class: "btn default-btn",
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.choosePaymentMode && _ctx.choosePaymentMode(...args)))
                }, _toDisplayString(_ctx.state.ui.isPostLoading.confirmPayment ? "Loading..." : "PAY"), 1)
              ]))
            : _createCommentVNode("", true),
          (
              _ctx.isAuthEdit &&
              _ctx.state.data.invoiceDetails &&
              _ctx.state.data.invoiceDetails.generated != 1 &&
              !_ctx.state.data.invoiceDetails.draft_uuid
            )
            ? (_openBlock(), _createBlock("li", _hoisted_101, [
                _createVNode("a", {
                  href: "javascript:void(0)",
                  class: "btn default-btn outline",
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.showGenerateConfirmation && _ctx.showGenerateConfirmation(...args)))
                }, "Generate Invoice")
              ]))
            : _createCommentVNode("", true),
          (
              _ctx.state.data.invoiceDetails &&
              _ctx.state.data.invoiceDetails.generated === 0 &&
              _ctx.state.data.invoiceDetails.user_role != 2 &&
              _ctx.state.data.isIndividual
            )
            ? (_openBlock(), _createBlock("li", _hoisted_102, [
                (
                _ctx.state.data.invoiceDetails &&
                !_ctx.state.data.invoiceDetails.draft_uuid
              )
                  ? (_openBlock(), _createBlock("a", {
                      key: 0,
                      href: "javascript:void(0)",
                      class: "btn default-btn outline draft-btn",
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.saveAsDraft && _ctx.saveAsDraft(...args)))
                    }, _toDisplayString(_ctx.state.ui.isPostLoading.saveAsDraft
                  ? "Loading..."
                  : "Save as Draft"), 1))
                  : (_openBlock(), _createBlock("a", {
                      key: 1,
                      href: "javascript:void(0)",
                      class: "btn default-btn outline draft-btn",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (
                _ctx.redirectToRequestedDraftInvoice(
                  _ctx.state.data.invoiceDetails.draft_uuid,
                  '1'
                )
              ))
                    }, "Go To Draft"))
              ]))
            : _createCommentVNode("", true),
          (
              _ctx.state.data.invoiceDetails &&
              _ctx.state.data.invoiceDetails.pdf_url &&
              _ctx.state.data.invoiceDetails.status != 4
            )
            ? (_openBlock(), _createBlock("li", _hoisted_103, [
                _createVNode("a", {
                  href: "javascript:void(0)",
                  class: "btn default-btn outline",
                  onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.downloadFile && _ctx.downloadFile(...args)))
                }, "Download Pdf")
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_104, [
      _createVNode("div", _hoisted_105, [
        _createVNode("div", _hoisted_106, [
          _createVNode("div", _hoisted_107, [
            _createVNode("div", _hoisted_108, [
              _hoisted_109,
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.hideAllInvoiceGenerate && _ctx.hideAllInvoiceGenerate(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_110
              ])
            ]),
            _createVNode("div", _hoisted_111, [
              _hoisted_112,
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.invoiceWithGenerated(1)))
              }, " Yes "),
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.invoiceWithGenerated(0)))
              }, " No ")
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_113, [
      _createVNode("div", _hoisted_114, [
        _createVNode("div", _hoisted_115, [
          _createVNode("div", _hoisted_116, [
            _createVNode("div", _hoisted_117, [
              _hoisted_118,
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.hideGenerateConfirmation && _ctx.hideGenerateConfirmation(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_119
              ])
            ]),
            _createVNode("div", _hoisted_120, [
              _createVNode(_component_ErrorList, {
                errors: _ctx.state.ui.error.errorList.getInvoiceByPhaseOrTask,
                hasError: _ctx.state.ui.error.hasError
              }, null, 8, ["errors", "hasError"]),
              _hoisted_121,
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.stripeAccountCheck && _ctx.stripeAccountCheck(...args)))
              }, _toDisplayString(_ctx.state.ui.isPostLoading.generateInvoice
                    ? "Loading..."
                    : "Generate Invoice"), 1),
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.hideGenerateConfirmation && _ctx.hideGenerateConfirmation(...args)))
              }, " No ")
            ])
          ])
        ])
      ])
    ]),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 2,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.successFulMessage,
          isButton: _ctx.ture
        }, {
          default: _withCtx(() => [
            (_ctx.state.data.stripeUrl)
              ? (_openBlock(), _createBlock("div", _hoisted_122, [
                  _hoisted_123,
                  (!_ctx.state.ui.isPostLoading.stripeAccount)
                    ? (_openBlock(), _createBlock("button", {
                        key: 0,
                        class: "btn-link mt-2",
                        onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.redirectToStripeAccount && _ctx.redirectToStripeAccount(...args)))
                      }, " Click to setup account. "))
                    : (_openBlock(), _createBlock("p", _hoisted_124, "Loading..."))
                ]))
              : _createCommentVNode("", true),
            (_ctx.state.data.stripeSuccess)
              ? (_openBlock(), _createBlock("div", _hoisted_125, [
                  (!_ctx.state.ui.isPostLoading.generateInvoice)
                    ? (_openBlock(), _createBlock("button", {
                        key: 0,
                        onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.generateInvoice(1)))
                      }, " Click to Generate Invoice "))
                    : (_openBlock(), _createBlock("p", _hoisted_126, "Loading..."))
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["onClose", "showModal", "titleMessage", "isButton"]))
      : _createCommentVNode("", true)
  ]))
}